import { Route } from '@angular/router';

export const SecurityMainRoute: Route = {
  path: 'security',
  loadComponent() {
    return import('@daas-consulting/production/shared/frontend/pages').then(
      (c) => c.LayoutBase2PageComponent
    );
  },
  loadChildren() {
    return import(
      '@daas-consulting/security/shared/frontend/security_shell'
    ).then((c) => c.SecurityShellRoutes);
  },
};
